// Components
import { ProtocolFunctionsDiv, CloseDiv, CloseButton, CloseImg, FunctionsImg } from "./styles";
import Popup from "../../../../../../../popup";
// Assets
import CloseIcon from "../../../../../../../../assets/icons/btn_close_gray.svg";
import ProtocolFunctionsImg from "../../../../../../../../assets/images/protocols/protocol_functions.png";

const ProtocolFunctions = ({ isShowingFunctionsPopup, setIsShowingFunctionsPopup }) => {
  return (
    <Popup isShowed={isShowingFunctionsPopup} setIsShowed={setIsShowingFunctionsPopup} backgroundId="functionsPopup">
      <ProtocolFunctionsDiv>
        <CloseDiv>
          <CloseButton onClick={() => setIsShowingFunctionsPopup(false)}>
            <CloseImg src={CloseIcon} alt="close-ico" />
          </CloseButton>
        </CloseDiv>
        <FunctionsImg src={ProtocolFunctionsImg} alt="functions-img" />
      </ProtocolFunctionsDiv>
    </Popup>
  );
};

export default ProtocolFunctions;
